/** Local glyph canvas size (px). */
export var SCHEMATIC_GLYPH_SIZE = 48;
